import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]




export default /*#__PURE__*/_defineComponent({
  __name: 'c-navlink',
  props: {
    to: {},
    link: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: { name: _ctx.to }
      }, {
        default: _withCtx(({ href, route, navigate, isActive, isExactActive }) => [
          _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ href, route, navigate, isActive, isExactActive })))
        ]),
        _: 3
      }, 8, ["to"]))
    : (_ctx.link)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.link,
          target: "_blank"
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
}
}

})